"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInventory = void 0;
const common_1 = require("../../common");
const models_1 = require("../../products/models");
const models_2 = require("../../setup/models");
const enums_1 = require("../enums");
class ProductInventory extends common_1.MongoDocument {
}
exports.ProductInventory = ProductInventory;
//# sourceMappingURL=product-inventory.model.js.map